import React from 'react';

import Skeleton from '@atlaskit/skeleton';

export const ParentIssueFieldSkeleton = (): React.JSX.Element => (
	<Skeleton testId="parent-issue-field-skeleton" width="250px" height="16px" isShimmering />
);
